import { atom, useAtom, useSetAtom } from "jotai";

export const jwtTokenAtom = atom<string | null>(null);

export const useJwtToken = () => useAtom(jwtTokenAtom);
export const useSetJwtToken = () => useSetAtom(jwtTokenAtom);
